import { ElementType } from '@utils/page-analytics/model/AnalyticTrackingBasePropertiesObj';

export enum PerformanceAnalysisView {
  Table = 'Table',
  LineChart = 'Line Chart',
  BarChart = 'Bar Chart',
  StackedBarChart = 'Stacked Chart',
}

export const PerformanceAnalysisViewMapping: Record<PerformanceAnalysisView, ElementType> = {
  [PerformanceAnalysisView.Table]: ElementType.TABLE,
  [PerformanceAnalysisView.LineChart]: ElementType.LINE_CHART,
  [PerformanceAnalysisView.BarChart]: ElementType.BAR_CHART,
  [PerformanceAnalysisView.StackedBarChart]: ElementType.STACKED_CHART,
};
